import { CSSProperties } from 'react'
import { colours } from '@headbox-ui/themes'

const { grey, white, teal } = colours

export const CONTENT_STYLE: CSSProperties = {
  backgroundColor: grey[98],
  boxSizing: 'content-box',
  margin: '0 auto',
  maxWidth: '1278px',
  padding: '0px 40px',
  minHeight: '100vh',
}

export const LAYOUT_STYLE = {
  margin: '0 auto',
  maxWidth: 2200,
  minHeight: '100%',
}

export const ITEM_STYLE = {
  height: '100%',
}

export const TABLE_STYLE: CSSProperties = {
  WebkitOverflowScrolling: 'touch',
  backgroundColor: white,
  maxWidth: '100%',
  overflowX: 'auto',
}

export const USER_AVATAR = {
  background: teal[100],
  color: teal[500],
  marginRight: 5,
}
